import request from './http';
export const config = () => request({
  url: '/jetlinks/authorize/captcha/config',
  method: 'GET'
});

export const front = () => request({
    url: '/jetlinks/system/config/front',
    method: 'GET'
});
